import safeStringify from "fast-safe-stringify";
import { HUYASdk } from "@huyafed/huya-kiwi";

import { createLogger } from "./createLogger";
import { getTime } from "./time";

const timestamp = Date.now();

function safetyStringify(value: unknown) {
  try {
    return safeStringify(value);
  } catch {
    return "";
  }
}

const logger = createLogger({
  onAfter(logInfo) {
    HUYASdk.log(`${logInfo.desc} ${safetyStringify(logInfo.data)}`);
  },
  prefix() {
    return `game-for-peace - camp * date:${getTime()} sessionId:${timestamp} - `;
  },
});

export default logger;
